import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Job } from 'server/shared/models/job';
import { Shift } from 'server/shared/models/shift';
import { ShiftEnum } from 'server/shared/models/shift.enum';
@Component({
  selector: 'app-job-list-item-date-time',
  templateUrl: './job-list-item-date-time.component.html',
  styleUrls: ['./job-list-item-date-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListItemDateTimeComponent {
  @Input() job?: Job;

  @Input() shifts?: Shift[];
  @Input() date?: Job['date'];
  @Input() withDate = false;

  constructor() {}

  protected readonly ShiftEnum = ShiftEnum;
}
